__turbopack_context__.v({
  "container": "PodcastSection-module-scss-module__b5Ksjq__container",
  "content": "PodcastSection-module-scss-module__b5Ksjq__content",
  "heading": "PodcastSection-module-scss-module__b5Ksjq__heading",
  "main": "PodcastSection-module-scss-module__b5Ksjq__main",
  "para": "PodcastSection-module-scss-module__b5Ksjq__para",
  "podcast_block": "PodcastSection-module-scss-module__b5Ksjq__podcast_block",
  "root": "PodcastSection-module-scss-module__b5Ksjq__root",
  "videoWrapper": "PodcastSection-module-scss-module__b5Ksjq__videoWrapper",
});
